<template>
  <job-alert-form :data="jobAlert"
                  :title="$t('jobAlert.edit.title')"
                  :submit-loading="submitLoading"
                  @submit="onSubmit">
  </job-alert-form>
</template>
<script>
import JobAlertForm from './JobAlertForm'
import JobAlertService from 'src/services/JobAlertService'
import LanguageSelect from 'src/components/LanguageSelect'

export default {
  components: {
    LanguageSelect,
    JobAlertForm,
  },
  data () {
    return {
      submitLoading: false,
      jobAlert: null,
    }
  },
  methods: {
    async getData () {
      let {data} = await JobAlertService.getById(this.$route.params.id)
      this.jobAlert = data
    },
    async onSubmit (data) {
      try {
        this.submitLoading = true
        await JobAlertService.update(data.uuid, data)
        this.$router.push('/talent/job-alerts')
      } finally {
        this.submitLoading = false
      }
    },
  },
  watch: {
    '$store.state.config.textLanguage' () {
      this.getData()
    },
  },
  async created () {
    await this.getData()
  }
}
</script>
<style>
</style>
